import { render } from "./StrategyTable.vue?vue&type=template&id=14b33260&scoped=true&ts=true"
import script from "./StrategyTable.vue?vue&type=script&lang=ts"
export * from "./StrategyTable.vue?vue&type=script&lang=ts"

import "./StrategyTable.vue?vue&type=style&index=0&id=14b33260&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b33260"]])

export default __exports__